<script setup lang="ts">
import AppButton from '@/components/ui/AppButton.vue'
import { useLang } from '@/composables/use-lang'
import { pinia } from '@/stores'
import { useRouterStore } from '@/stores/router'
import TimesUpContent from '@/lang/times-up.json'

const { push } = useRouterStore(pinia)

const langContent = useLang(TimesUpContent)

const handleNext = () => {
  push('address')
}
</script>

<template>
  <div v-if="langContent" class="text-center">
    <h2>{{ langContent.heading }}</h2>
    <p>{{ langContent.message }}</p>
    <app-button class="mx-auto mt-10" @click="handleNext">{{ langContent.retry }}</app-button>
  </div>
</template>
